const toSnakeCase = (string: string | null | undefined): string => {
  if (!string) {
    return ''
  }
  return string.replace(/(?:^|\.?)([A-Z])/g, (x, y): string => `_${y.toLowerCase()}`).replace(/^_/, '')
}

export default toSnakeCase
